<!-- Copyright (c) 2025 MOCA Systems, Inc. All rights reserved. -->

<div class="print-panel-box" [class.collapsed]="collapsed">
	<div class="panel-header">
		<mat-icon automationId="expandButton" class="expand-button" (click)="toggleCollapse()"
			>{{ collapsed ? 'arrow_menu_close' : 'arrow_menu_open' }}
		</mat-icon>
		<h1 class="panel-title">{{ appStrings.PLAN_PRINT_TITLE }}</h1>
		<button class="filters-button" mat-button automationId="printButton" (click)="onOpenPlanFilter()">
			{{ appStrings.PLAN_PRINT_FILTERS_ACTION }}
			<mat-icon>discover_tune</mat-icon>
		</button>
		<mat-icon automationId="closeButton" class="close-button" (click)="onClose()">close</mat-icon>
	</div>
	<mat-divider></mat-divider>
	<plan-print-settings *ngIf="!collapsed"></plan-print-settings>
</div>
